import { Box, Typography, Chip, Paper, Grid, Divider } from '@mui/material';

const STATUS_MAP = {
  bozza: { label: 'Bozza', color: 'default' },
  incompleta: { label: 'Incompleta', color: 'warning' },
  completata: { label: 'Completata', color: 'success' },
  inviata: { label: 'Inviata', color: 'primary' },
};

const SECTION_FIELDS = {
  'Pratica': ['pratica_id', 'numero_preventivo', 'numero_polizza', 'intermediario', 'prodotto_compagnia', 'importo_finanziare', 'premio_polizza', 'data_apertura'],
  'Soggetto': ['tipo_soggetto', 'ha_coobbligato', 'grado_parentela'],
  'Anagrafica': ['cognome', 'nome', 'data_nascita', 'luogo_nascita', 'codice_fiscale', 'sesso', 'stato_civile'],
  'Residenza': ['residenza_indirizzo', 'residenza_civico', 'residenza_cap', 'residenza_localita', 'residenza_provincia', 'tipo_abitazione'],
  'Recapiti': ['cellulare', 'email', 'telefono_fisso'],
  'Documento': ['tipo_documento', 'numero_documento', 'data_rilascio', 'ente_rilascio'],
  'Cittadinanza': ['cittadinanza', 'cittadinanza_altra'],
  'Occupazione': ['attivita_lavorativa', 'settore_attivita', 'tipo_assunzione'],
  'Datore': ['datore_ragione_sociale', 'datore_localita'],
  'Reddito': ['tipo_reddito', 'numero_mensilita', 'reddito'],
  'Socio-Demografici': ['numero_familiari', 'rapporto_banca_posta', 'carta_credito'],
  'Pagamento': ['modalita_pagamento', 'codice_iban', 'intestatario_conto'],
};

const LABELS = {
  pratica_id: 'ID Pratica', numero_preventivo: 'N° Preventivo', numero_polizza: 'N° Polizza',
  intermediario: 'Intermediario', prodotto_compagnia: 'Prodotto', importo_finanziare: 'Importo',
  premio_polizza: 'Premio', data_apertura: 'Data Apertura', tipo_soggetto: 'Tipo Soggetto',
  ha_coobbligato: 'Coobbligato', grado_parentela: 'Parentela', cognome: 'Cognome', nome: 'Nome',
  data_nascita: 'Data Nascita', luogo_nascita: 'Luogo Nascita', codice_fiscale: 'Codice Fiscale',
  sesso: 'Sesso', stato_civile: 'Stato Civile', residenza_indirizzo: 'Indirizzo',
  residenza_civico: 'Civico', residenza_cap: 'CAP', residenza_localita: 'Località',
  residenza_provincia: 'Provincia', tipo_abitazione: 'Tipo Abitazione', cellulare: 'Cellulare',
  email: 'Email', telefono_fisso: 'Telefono Fisso', tipo_documento: 'Tipo Documento',
  numero_documento: 'N° Documento', data_rilascio: 'Data Rilascio', ente_rilascio: 'Ente Rilascio',
  cittadinanza: 'Cittadinanza', cittadinanza_altra: 'Specificare', attivita_lavorativa: 'Attività',
  settore_attivita: 'Settore', tipo_assunzione: 'Assunzione', datore_ragione_sociale: 'Ragione Sociale',
  datore_localita: 'Località', tipo_reddito: 'Tipo Reddito', numero_mensilita: 'Mensilità',
  reddito: 'Reddito', numero_familiari: 'Familiari', rapporto_banca_posta: 'Rapporto Bancario',
  carta_credito: 'Carta', modalita_pagamento: 'Modalità', codice_iban: 'IBAN',
  intestatario_conto: 'Intestatario',
};

function formatValue(key, value) {
  if (value === undefined || value === null || value === '') return '—';
  if (typeof value === 'boolean') return value ? 'Sì' : 'No';
  if (typeof value === 'number') {
    if (key.includes('importo') || key.includes('premio') || key === 'reddito') {
      return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(value);
    }
    return String(value);
  }
  return String(value);
}

export default function SummaryView({ data }) {
  const status = STATUS_MAP[data.stato_pratica] || STATUS_MAP.bozza;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Riepilogo dati</Typography>
        <Chip label={status.label} color={status.color} size="small" sx={{ ml: 'auto' }} />
      </Box>

      {Object.entries(SECTION_FIELDS).map(([section, fields]) => {
        const hasData = fields.some(f => data[f] !== undefined && data[f] !== null && data[f] !== '');
        if (!hasData) return null;

        return (
          <Paper key={section} variant="outlined" sx={{ p: 1.5, borderRadius: 2, bgcolor: 'action.hover' }}>
            <Typography variant="overline" sx={{ fontWeight: 700, color: 'text.secondary', display: 'block', mb: 1, lineHeight: 1.5 }}>
              {section}
            </Typography>
            <Grid container spacing={1}>
              {fields.map(f => {
                const val = data[f];
                if (val === undefined || val === null || val === '') return null;
                return (
                  <Grid item xs={12} key={f}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 0.5 }}>
                      <Typography variant="caption" color="text.secondary">{LABELS[f] || f}</Typography>
                      <Typography variant="caption" sx={{ fontWeight: 500, textAlign: 'right', maxWidth: '60%' }} noWrap>
                        {formatValue(f, val)}
                      </Typography>
                    </Box>
                    <Divider sx={{ opacity: 0.5 }} />
                  </Grid>
                );
              })}
            </Grid>
          </Paper>
        );
      })}
    </Box>
  );
}